import * as React from "react";
import { MenuType, LeaderboardMetric } from "@/types/leader-board";
import UserLeaderBoardInfo from "./user-leader-board-info";
import ShareButton from "@/components/atomics/share-button";
import MotionModal from "@/components/atomics/motion-modal";
import LeaderBoardBoost from "./leader-board-boost";
import LeaderBoardShare from "./leader-board-share";
import { useState } from "react";

interface OwnerLeaderBoardItemProps {
  rank: number;
  name: string;
  value: number;
  address: string;
  avatar: string;
  ownerAddress: string;
  selectedMenu: MenuType;
  metric: LeaderboardMetric;
  indexInCollection?: number;
}

export default function OwnerLeaderBoardItem({
  rank,
  name,
  value,
  address,
  avatar,
  ownerAddress,
  selectedMenu,
  metric,
  indexInCollection,
}: OwnerLeaderBoardItemProps) {
  const [isOpenShare, setIsOpenShare] = useState(false);
  const [isOpenBoost, setIsOpenBoost] = useState(false);

  const handleCloseShare = () => {
    setIsOpenShare(false);
  };

  const handleCloseBoost = () => {
    setIsOpenBoost(false);
  };

  const handleOpenShare = () => {
    setIsOpenShare(true);
  };

  const handleOpenBoost = () => {
    setIsOpenBoost(true);
  };

  return (
    <div key={rank} className="w-full flex justify-between">
      <MotionModal isOpen={isOpenShare}>
        <LeaderBoardShare
          userInfo={{
            rank,
            name,
            value,
            address,
            avatar,
            ownerAddress,
            indexInCollection,
          }}
          initialSelectedMenu={selectedMenu}
          initialMetric={metric}
          onClickClose={handleCloseShare}
        />
      </MotionModal>

      <MotionModal isOpen={isOpenBoost}>
        <LeaderBoardBoost
          userInfo={{
            rank,
            name,
            value,
            address,
            avatar,
            ownerAddress,
            indexInCollection,
          }}
          selectedMenu={selectedMenu}
          metric={metric}
          onClickClose={handleCloseBoost}
        />
      </MotionModal>

      <UserLeaderBoardInfo
        userInfo={{
          rank,
          name,
          value,
          address,
          avatar,
          ownerAddress,
          indexInCollection,
        }}
        selectedMenu={selectedMenu}
        metric={metric}
        myrank={true}
        onClickRankBoost={metric === "all_stars" ?  handleOpenBoost : undefined}
      />

      <div className="flex items-center sm:p-8 p-6 bg-[#006DB5] hover:cursor-pointer" onClick={handleOpenShare}>
        <ShareButton
          className="w-[24px] h-[34px] hover:cursor-pointer"
          color={"#ffffff"}
          onClick={handleOpenShare}
        />
      </div>
    </div>
  );
}
